import { render, staticRenderFns } from "./MoveEntryModal.vue?vue&type=template&id=ef049bd0"
import script from "./MoveEntryModal.vue?vue&type=script&lang=ts"
export * from "./MoveEntryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports